import { getOmniSmusConfig } from 'src/api/config';
import omnismusservice, {
  RegisterSsoGroupRequest,
  RegisterSsoGroupResponse,
  AssociateAccountRequest,
  AssociateAccountResponse,
  ListSsoGroupsRequest,
  ListSsoGroupsResponse,
  ListSsoGroupResourcesRequest,
  ListSsoGroupResourcesResponse,
  GetSsoGroupRequest,
  GetSsoGroupResponse,
} from 'aws-sdk/clients/omnismusservice';
import basicCallWrapper from 'src/api/client_call';

const config = getOmniSmusConfig();

let omniSmusClient = new omnismusservice();

export async function initOmniSmusServiceClient(credentials) {
  const omniSmusServiceServiceClientConfig = {
    region: config.region,
    endpoint: config.endpoint,
    credentials: credentials,
  };

  omniSmusClient = new omnismusservice(omniSmusServiceServiceClientConfig);
}

export const registerSsoGroup = (request: RegisterSsoGroupRequest) => {
  return basicCallWrapper<RegisterSsoGroupRequest, RegisterSsoGroupResponse>(
    omniSmusClient,
    omniSmusClient.registerSsoGroup,
  )(request);
};

export const associateAccount = (request: AssociateAccountRequest) => {
  return basicCallWrapper<AssociateAccountRequest, AssociateAccountResponse>(
    omniSmusClient,
    omniSmusClient.associateAccount,
  )(request);
};

export const listSsoGroups = (request: ListSsoGroupsRequest) => {
  return basicCallWrapper<ListSsoGroupsRequest, ListSsoGroupsResponse>(
    omniSmusClient,
    omniSmusClient.listSsoGroups,
  )(request);
};

export const getSsoGroup = (request: GetSsoGroupRequest) => {
  return basicCallWrapper<GetSsoGroupRequest, GetSsoGroupResponse>(omniSmusClient, omniSmusClient.getSsoGroup)(request);
};

export const listSsoGroupResources = (request: ListSsoGroupResourcesRequest) => {
  return basicCallWrapper<ListSsoGroupResourcesRequest, ListSsoGroupResourcesResponse>(
    omniSmusClient,
    omniSmusClient.listSsoGroupResources,
  )(request);
};
